import React from 'react'
import { Route } from '@fs/zion-router'
import { useAppProvider } from '../../providers/AppProvider'
import { AuthRouteWrapper } from './AuthRouteWrapper'

const PrisonReportsAuth = ({ component: Component, children, ...rest }) => {
  const {
    prisonReportsPermission: { hasPermission, loading },
  } = useAppProvider()

  return (
    <Route
      {...rest}
      render={(props) => (
        <AuthRouteWrapper authorized={hasPermission} loading={loading} redirectTo="/unauthorized" {...rest}>
          {children || <Component {...props} />}
        </AuthRouteWrapper>
      )}
    />
  )
}

export default PrisonReportsAuth
